import script from "./MFormularioAtividadeComAtributos.vue?vue&type=script&lang=ts&setup=true"
export * from "./MFormularioAtividadeComAtributos.vue?vue&type=script&lang=ts&setup=true"

import "./MFormularioAtividadeComAtributos.vue?vue&type=style&index=0&id=6d9974d5&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d9974d5"]])

export default __exports__